<div class="container-fluid " style="background-color: #d0d0d0">
     <div class="container">
        <div class="row">
            <div class="login-left text-left align-self-center col-xl-5 col-md-6 col-xs-12">
                <!-- <img src="assets/images/logo.png" alt=""> -->
                <div class="m-3">&nbsp;</div>
                <p>Redirecting...</p>
                <div class="error" *ngIf="serverError != ''">{{serverError}}</div>
            </div>
        </div>
    </div>
</div>
